import type { AnyObj } from '@/types';

export default {
  /**
   * 获取详情地址文本
   * @param data
   * @returns
   */
  getText: (data: AnyObj) => {
    if (!data?.province) return '';
    return `${data.province}${data.city}${data.district || data.customFields?.district || ''}${
      data.streetLine1
    }${data.streetLine2}`;
  },
  /**
   * 获取用户收货地址 uni.chooseAddress
   */
  getUniAddress: () => {
    return new Promise((resolve, reject) => {
      uni.chooseAddress({
        success: (res) => {
          resolve(res);
        },
        fail: (err) => {
          reject(err);
        },
      });
    });
  },
};
